import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnSheetCloseButton, VnSheetHeader } from "@/components/VnSheet";
import { VnText } from "@/components/VnText/VnText";

type SideSheetHeaderPropsType = {
  title: string;
  subtitle?: string;
};

export const SideSheetHeader: FC<SideSheetHeaderPropsType> = ({
  title,
  subtitle,
}) => {
  return (
    <VnSheetHeader className="flex-col items-center gap-2 p-0 pb-4">
      <VnBox className="relative w-full items-center justify-center">
        <VnText variant="headerTwo">{title}</VnText>
        <VnBox className="border-border bg-background absolute right-0 rounded-md border">
          <VnSheetCloseButton />
        </VnBox>
      </VnBox>
      {subtitle && (
        <VnText variant="lg" className="text-muted-foreground text-center">
          {subtitle}
        </VnText>
      )}
    </VnSheetHeader>
  );
};
